import { useTranslation } from "react-i18next";
import { InformationBarProps } from "./information-bar.types";
import { useCallback, useEffect, useMemo, useState } from "react";
import {
  makeUrl,
  debounce,
  useAppLocation,
  useAppSearchParams,
  useAnalytics,
} from "@commons-monorepo/index";

export const useInformationBar = ({
  information,
  offer,
  storeMetadata,
}: InformationBarProps) => {
  const { t } = useTranslation();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { pathname } = useAppLocation();
  const [searchParams] = useAppSearchParams();

  const [showBar, setShowBar] = useState(true);
  const [currentScroll, setCurrentScroll] = useState(0);

  const handleScrollChangeShow = useCallback(
    debounce(() => {
      setShowBar(true);
      setCurrentScroll(window.scrollY);
    }, 1000),
    [],
  );

  const isInformationBarPreview = useMemo(
    () => !!searchParams.get("information-bar"),
    [searchParams],
  );

  const offerLink = useMemo(() => {
    return isInformationBarPreview
      ? `${pathname}?${searchParams.toString()}`
      : makeUrl(
          pathname,
          information.offerId
            ? `oferta/${offer?.link || information.offerId}`
            : "ofertas",
        );
  }, [information, offer, pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (Math.abs(window.scrollY - currentScroll) > 100) {
        if (showBar) {
          setShowBar(false);
        }
        handleScrollChangeShow();
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentScroll]);

  return {
    t,
    logEvent,
    showBar,
    offerLink,
    isInformationBarPreview,
  };
};
